import { render, staticRenderFns } from "./wholePerson.vue?vue&type=template&id=d7c44f62"
import script from "./wholePerson.vue?vue&type=script&lang=js"
export * from "./wholePerson.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports